import { titleCase } from 'shared';
/** Display name for a bank account, e.g. "Chase Checking". */
function formatBankAccountLabel(account) {
    const parts = [
        account.bankName,
        account.accountType && titleCase(account.accountType),
    ]
        .filter(Boolean)
        .join(' ');
    return parts || account.accountName || 'Bank Account';
}
export default formatBankAccountLabel;
